import FormOpener from "./FormOpener";
import Autocompleters from "./Autocompleters";
//import "intl-tel-input/build/css/intlTelInput.css";
//import "../../css/intlTelInputOverride.css";
import intlTelInput from "intl-tel-input";
import {countriesNames} from "./form-countries/CountriesNames";
import {countriesNamesSalesforce} from "./form-countries/CountriesNamesSalesforce";
import {countriesIso} from "./form-countries/CountriesIso";

export default class LeadForm {
    get SELECTORS (){
        return {
            submitBtn : '#leadform .leadform__submit__cta',
            loadingSubmitBtn: '#leadform .leadform__submit__loading',
            phoneLabel : '.form-group--phone label',
            itiSelectedDialCode: '.iti__selected-dial-code',
        }
    }
    constructor() {
        new FormOpener();
        //    TODO: Autofill fb doesnt work correctly, uncomment below to check & fix
        new Autocompleters();
        this.recaptcha_token = document.querySelector("#g_recaptcha_token");
        this.countryInputName = document.querySelector("[data-country-input-name]");
        this.countryInputIso2 = document.querySelector("[data-country-input-iso2]");
        this.countryInputIso3 = document.querySelector("[data-country-input-iso3]");
        this.phonePrefix = document.querySelector("#phone_prefix");
        this.phoneInput = document.querySelector("#phone");
        this.phoneLabel = document.querySelector(this.SELECTORS.phoneLabel);
        this.leadForm = document.querySelector("#leadform");
        this.ctaSubmitBtn = document.querySelector(this.SELECTORS.submitBtn);
        this.loadingSubmitBtn = document.querySelector(this.SELECTORS.loadingSubmitBtn);
        this.intlTelInput = null;
        this.oldValPhoneInput = null;
        this.subDirectory = 'landing_pages';
        this.geoIpLookupSuccess = this.geoIpLookupSuccess.bind(this);

        if (this.countryInputName && this.phonePrefix && this.phoneInput) {
            //this is tricky because of intl-tel-input:
            // we need to empty input value if old value was setup after send form.
            this.getOldPhoneValue();
            this.instanceIntlTelInput();
            this.addPhoneListeners();
        }

        if (this.leadForm && this.ctaSubmitBtn && this.loadingSubmitBtn) {
            this.registerSubmit();
        }
    }

    getOldPhoneValue(){
        //from  intl-tel-input docs:  Note that the "auto" option will not update the country
        // selection if the input already contains a number.
        if(this.phoneInput.value.length >0){
            this.oldValPhoneInput = this.phoneInput.value;
            this.phoneInput.value = '';
        }
    }
    setOldPhoneValue(){
        if(this.oldValPhoneInput){
            this.phoneInput.value = this.oldValPhoneInput;
            this.phoneInputSelect();
        }
    }

    phoneInputSelect(){
        if (this.phoneInput.value) {
            this.phoneLabel.classList.add("selected");
        }
    }
    instanceIntlTelInput(){
        let subDirectory = window.location.pathname.includes(this.subDirectory) ? '/' + this.subDirectory : '';
        let url = window.location.protocol + '//' + window.location.host + subDirectory + '/geolocation';
        this.intlTelInput = intlTelInput(this.phoneInput, {
            //from docs:  Note that the "auto" option will not update the country
            // selection if the input already contains a number.
            initialCountry: "auto",
            preferredCountries: ["it"],
            geoIpLookup: (success, failure) => {
                fetch(url)
                .then(response => response.json())
                .then(response => {
                    const countryCode =
                        response && response.country
                            ? response.country
                            : "it";
                    success(countryCode);
                })
                .catch(response => {
                    console.log("Cannot fetch phone prefixes");
                    failure("Cannot fetch phone prefixes");
                });
            },
            separateDialCode: true,
            excludeCountries: ['ac'],
            localizedCountries: countriesNames
        });

        //once fetch from 'geoIpLookup' option was completed we set back the old value
        this.intlTelInput.promise.then(this.geoIpLookupSuccess);

    }
    geoIpLookupSuccess(){
        this.setOldPhoneValue();
        this.phoneInputSelect();
    }
    setCountry () {
        let countryIso = this.intlTelInput
        .getSelectedCountryData()
        .iso2;
        let countryName = countriesNamesSalesforce[countryIso];
        let countryCode = this.intlTelInput.getSelectedCountryData().dialCode;
        let countryPlaceholder = document.querySelector(this.SELECTORS.itiSelectedDialCode);
        countryPlaceholder.innerHTML = `+${countryCode} ${countryName}`;
        this.countryInputName.value = countryName;
        this.countryInputIso2.value = countryIso;
        this.countryInputIso3.value = countriesIso[countryIso];
        this.phonePrefix.value = "+" + countryCode;
    }

    addPhoneListeners(){
        this.phoneInput.addEventListener("countrychange", (e) => {
            this.setCountry();
        });

        this.phoneInput.addEventListener("keyup", event => {
            this.setCountry();
        });

        this.phoneInput.addEventListener("focus", () => {
            this.phoneLabel.classList.add("selected");
        });

        this.phoneInput.addEventListener("blur", () => {
            if (this.phoneInput.value.length === 0) {
                this.phoneLabel.classList.remove("selected");
            }
        });
    }

    registerSubmit() {
        this.leadForm.addEventListener("submit", evt => {
            if (this.ctaSubmitBtn.disabled) {
                evt.preventDefault();
                return;
            }
            evt.preventDefault();
            grecaptcha.ready(() => {
                grecaptcha.execute('6Lc6SuoaAAAAAG71rLtEq1-F-xuPit_XEM_alNEE', {action: 'submit'}).then(token => {
                    this.recaptcha_token.value = token;
                    evt.target.submit();
                });
            });

            this.ctaSubmitBtn.disabled = true;
            this.ctaSubmitBtn.classList.add("hidden");
            this.loadingSubmitBtn.classList.remove("hidden");
        });
    }
}
